import React from 'react';
import SearchForm from './components/SearchForm';
import Stories from './components/Stories';
import Buttons from './components/Buttons';

function App() {
  return (
    <>
      <SearchForm />
      <Buttons />
      <Stories />
    </>
  );
}

export default App;
